import {connect, State} from '@modifi/redux'

import DeleteEntryConfirmDialog from '../../../plugins/onboarding/dialogs/delete-entry-confirm-dialog'
import {
  selectDeleteErrorMessage,
  selectDeleteIsPending,
  aResetDeleteSellerBankAccount,
} from '../store'

const mapStateToProps = (state: State): {deletePending: boolean; deleteErrorMessage?: string} => ({
  deletePending: selectDeleteIsPending(state),
  deleteErrorMessage: selectDeleteErrorMessage(state),
})

const mapDispatchToProps = {
  reset: aResetDeleteSellerBankAccount,
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteEntryConfirmDialog)

export const DELETE_SELLER_BANK_DIALOG_NAME = 'onboarding/DELETE_SELLER_BANK_ACCOUNT_CONFIRM_DIALOG'
